import { render, staticRenderFns } from "./Zeeland.vue?vue&type=template&id=6ea64bb3&"
var script = {}
import style0 from "./Zeeland.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Zeeland.vue"
export default component.exports